<div class="d3-chart">
  <div class="chart" #chart>

  </div>
  <div class="legend" #legend>

  </div>
</div>
